let observer = null;

function observeSelector(element) {
  if (element) {
    const parentNode = element.parentNode || document.body;
    const newClonedNode = element.cloneNode(true);
    if (observer) {
      observer.disconnect();
    }
    new MutationObserver((mutations, obs) => {
      observer = obs;
      mutations.forEach(mutationRecord => {
        const currentTarget = mutationRecord.target;
        const removedNode = mutationRecord.removedNodes[0];
        // 修改属性的时候，target就是当前元素
        if (currentTarget === element) {
          const replaceNode = newClonedNode.cloneNode(true);
          parentNode.replaceChild(replaceNode, element);
          element = replaceNode;
        } else {
          // 删除元素的时候，removedNodes是一个数组，只删它一个，那第一个就是当前元素
          if (removedNode === element) {
            element = element.cloneNode(true);
            parentNode.appendChild(element);
          }
        }
      });
    }).observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true, // 监听后代节点变化
    });
  }
}

export const addWaterMarker = (str, deepen) => {
  let maskEl = document.querySelector('.g-watermarker-mask');
  if (!maskEl) {
    maskEl = document.createElement('div');
    maskEl.className = 'g-watermarker-mask';
    document.body.appendChild(maskEl);
  }
  const canvas = document.createElement("canvas");
  const ratio = window.devicePixelRatio;
  canvas.width = 320 * ratio;
  canvas.height = 250 * ratio;
  const ctx = canvas.getContext("2d");
  ctx.rotate(-15 * Math.PI / 150); //旋转弧度
  ctx.font = `${16 * ratio}px Microsoft JhengHei`; //字体
  ctx.fillStyle = deepen ? 'rgba(240, 128, 128, 1)' : `rgba(96, 98, 102, 0.12)`; //字体填充颜色
  ctx.textAlign = "left"; //对齐方式
  ctx.textBaseline = "Middle"; //基线
  ctx.fillText(str, 0, canvas.height * 0.33); //被填充的文本
  ctx.fillText(str, canvas.width * 0.33, canvas.height - 16 * ratio); //被填充的文本
  maskEl.style.backgroundImage = `url(${canvas.toDataURL("image/png")})`; //插入背景图
  observeSelector(maskEl);
};

export const removeWaterMarker = () => {
  if (observer) {
    observer.disconnect();
  }
  let maskEl = document.querySelector('.g-watermarker-mask');
  if (maskEl) {
    maskEl.parentNode.removeChild(maskEl);
  }
};
